export default {
    namespaced: true,
    state: {
        selectedGroups: [],
        selectedGroupsFullInfo: [],
        currentRoute: 'ca-home',
        acceptedRoutes: {
            HOME: 'ca-home',
            DEADLINE: 'ca-deadline',
            SELECTEDS: 'ca-selecteds'
        },
        portions: [],
        overviewSimulation: {},
        currentDeadlineNumber: 150,
        removedPortions: [],
        selectedPortions: [],
        xmlPortions: {
            withXml: [],
            withoutXml: [],
        },
        fromHome: false,
        selectedDeadlineBox: null,
        xmlAssociationOrders: [],
        filters: {
            filterDateDue: {
                start: null,
                end: null,
            },
            filterDateEmission: {
                start: null,
                end: null,
            },
            orderStatus: null,
            portions: null,
        },
        dateRange: {
            start: null,
            end: null,
        },
        autoOffers: [],
        manualSponsors: 0,
        availableCreditLimits: [],
        selectedTotalValue: 0,
        filteredAvailableCreditLimits: [],
        allAutoOffers: [],
    },
    mutations: {
        setSelectedGroups(state, selectedGroups){
            Object.assign(state, { selectedGroups });
        },
        setSelectedGroupsFullInfo(state, selectedGroupsFullInfo){
            Object.assign(state, { selectedGroupsFullInfo });
        },
        setCurrentRoute(state, currentRoute){
            Object.assign(state, { currentRoute });
        },
        setPortions(state, portions){
            Object.assign(state, { portions })
        },
        setOverviewSimulation(state, overviewSimulation){
            Object.assign(state, { overviewSimulation })
        },
        setCurrentDeadlineNumber(state, currentDeadlineNumber){
            Object.assign(state, { currentDeadlineNumber })
        },
        addRemovedPortions(state, removedPortions){
            state.removedPortions.push(removedPortions)
        },
        deleteRemovedPortions(state, removedPortions){
            const portions = state.removedPortions.filter(id => !removedPortions.includes(id))
            console.log(state.removedPortions)
            console.log(removedPortions)
            Object.assign(state, { removedPortions: portions })
        },
        setXmlPortionsWithXml(state, withXml){
            state.xmlPortions.withXml = withXml
        },
        setXmlPortionsWithoutXml(state, withoutXml){
            state.xmlPortions.withoutXml = withoutXml
        },
        setSelectedDeadlineBox(state, selectedDeadlineBox){
            Object.assign(state, { selectedDeadlineBox })
        },
        setXmlAssociationOrders(state, xmlAssociationOrders){
            Object.assign(state, { xmlAssociationOrders })
        },
        setAutoOffers(state, autoOffers){
            state.autoOffers = autoOffers
        },
        setAllAutoOffers(state, autoOffers){
            state.allAutoOffers = autoOffers
        },
        setManualSponsors(state, manualSponsors){
            state.manualSponsors = manualSponsors
        },
        clearPortions(state){
            state.portions = []
        },
        clearRemovedPortions(state){
            state.removedPortions = []
        },
        clearXmlPortionsWithXml(state){
            state.xmlPortions.withXml = []
        },
        clearXmlPortionsWithoutXml(state){
            state.xmlPortions.withoutXml = []
        },
        clearXmlAssociationOrders(state){
            state.xmlAssociationOrders = []
        },
        clearSelectedGroups(state){
            state.selectedGroups = []
        },
        clearSelectedGroupsFullInfo(state){
            state.selectedGroupsFullInfo = []
        },
        clearAutoOffers(state){
            state.autoOffers = []
            state.allAutoOffers = []
        },
        clearManualSponsors(state){
            state.manualSponsors = 0
        },
        updateXmlAssociationOrders(state, order){ // Portion Id, cuz it is more unique than others attributes
            const updated = state.xmlAssociationOrders.map((assocOrder) => {
                if (order.portionsId === assocOrder.portionsId){
                    return order
                }

                return assocOrder
            })
            
            Object.assign(state, { xmlAssociationOrders: updated })
            
        },
        deleteOneXmlAssociationOrder(state, order){
            const deleted = state.xmlAssociationOrders.filter((assocOrder) => {
                return order.portionsId !== assocOrder.portionsId
            })

            Object.assign(state, { xmlAssociationOrders: deleted })

        },
        deleteOneXmlPortionWithoutXml(state, portionId){
            const deleted = state.xmlPortions.withoutXml.filter((assocOrder) => {
                return portionId !== assocOrder.id
            })

            state.xmlPortions.withoutXml = deleted
        },
        setDateRange(state, dateRange){
            Object.assign(state, { dateRange })
        },
        clearDateRange(state) {
            Object.assign(state, { dateRange: { start: null, end: null } })
        },
        setFilters(state, filters){
            Object.assign(state, {filters})
        },
        clearFilters(state) {
            Object.assign(state, {
                filterDateDue: {
                    start: null,
                    end: null,
                },
                filterDateEmission: {
                    start: null,
                    end: null,
                },
                orderStatus: null,
                portions: null,
            })
        },

        addSelectedPortions(state, selectedPortions){
            state.selectedPortions.push(...selectedPortions)
            
            // !Needs to create actions to dont repeat this code
            state.selectedTotalValue = state.portions.reduce((total, { id, valueWithDiscount }) => {
                if(state.selectedPortions.includes(id)){
                    return total + valueWithDiscount
                }

                return total
            }, 0)
            // !Needs to create actions to dont repeat this code
            state.autoOffers = state.allAutoOffers.filter((autoOffer) => {
                if(!state.availableCreditLimits.length) return true
                return state.availableCreditLimits.find((avail) => {
                    return (
                        avail.sponsorId == autoOffer.sponsorId 
                        && avail.availableCreditLimit >= state.selectedTotalValue
                    )
                })
            })
        },
        removeSelectedPortions(state, selectedPortions){
            const portions = state.selectedPortions.filter(id => !selectedPortions.includes(id))
            Object.assign(state, { selectedPortions: portions })
            
            // !Needs to create actions to dont repeat this code
            state.selectedTotalValue = state.portions.reduce((total, { id, valueWithDiscount }) => {
                if(state.selectedPortions.includes(id)){
                    return total + valueWithDiscount
                }

                return total
            }, 0)
            // !Needs to create actions to dont repeat this code
            state.autoOffers = state.allAutoOffers.filter((autoOffer) => {
                if(!state.availableCreditLimits.length) return true
                return state.availableCreditLimits.find((avail) => {
                    return (
                        avail.sponsorId == autoOffer.sponsorId 
                        && avail.availableCreditLimit >= state.selectedTotalValue
                    )
                })
            })
        },
        setSelectedPortions(state, selectedPortions) {
            if(selectedPortions) {
                state.selectedPortions = [... new Set(selectedPortions)]
                // !Needs to create actions to dont repeat this code
                state.selectedTotalValue = state.portions.reduce((total, { id, valueWithDiscount }) => {
                    if(state.selectedPortions.includes(id)){
                        return total + valueWithDiscount
                    }

                    return total
                }, 0)
                // !Needs to create actions to dont repeat this code
                state.autoOffers = state.allAutoOffers.filter((autoOffer) => {
                    if(!state.availableCreditLimits.length) return true
                    return state.availableCreditLimits.find((avail) => {
                        return (
                            avail.sponsorId == autoOffer.sponsorId 
                            && avail.availableCreditLimit >= state.selectedTotalValue
                        )
                    })
                })
                return
            }

            // !Needs to create actions to dont repeat this code
            state.selectedTotalValue = state.portions.reduce((total, { id, valueWithDiscount }) => {
                if(state.selectedPortions.includes(id)){
                    return total + valueWithDiscount
                }

                return total
            }, 0)

            // !Needs to create actions to dont repeat this code
            state.autoOffers = state.allAutoOffers.filter((autoOffer) => {
                if(!state.availableCreditLimits.length) return true
                return state.availableCreditLimits.find((avail) => {
                    return (
                        avail.sponsorId == autoOffer.sponsorId 
                        && avail.availableCreditLimit >= state.selectedTotalValue
                    )
                })
            })

            let availableCreditLimit = state.availableCreditLimits[0]?.availableCreditLimit

            const sortedPortions = state.portions.sort((first, second) => {
                const firstDate = new Date(first.extensionDate || first.dVenc)
                const secondDate = new Date(second.extensionDate || second.dVenc)

                return firstDate - secondDate
            })
            
            sortedPortions.forEach((portion) => {
                if(!availableCreditLimit) state.selectedPortions.push(portion.id)
                
                const currentValue = availableCreditLimit - portion.valueWithDiscount
                if(currentValue < 0) return
                
                state.selectedPortions.push(portion.id)
                
                availableCreditLimit = currentValue

            })

            state.selectedPortions = [... new Set(state.selectedPortions)]
        },
        setRemovedPortions(state, removedPortions) {
            Object.assign(state, { removedPortions })
        },
        resetSelectedPortions(state) {
            Object.assign(state, { selectedPortions: [] })
        },
        setFromHome(state) {
            Object.assign(state, { fromHome: true })
        },
        resetFromHome(state) {
            Object.assign(state, { fromHome: false })
        },
        setAvailableCreditLimits(state, availableCreditLimits){
            state.availableCreditLimits = availableCreditLimits
        },
        setFilteredAvailableCreditLimits(state, availableCreditLimits){
            state.filteredAvailableCreditLimits = availableCreditLimits
        },
        clearCreditLimits(state){
            state.availableCreditLimits = []
            state.filteredAvailableCreditLimits = []
        },
    },
}